export enum ROLES {
    /**
     * @value Add restrictions
     */
    ADD_RESTRICTIONS = 'ROLES.ADD_RESTRICTIONS',
    /**
     * @value The groups assigned to this role inherit the role permissions.
     */
    ASSIGN_ROLES_DESCRIPTION = 'ROLES.ASSIGN_ROLES_DESCRIPTION',
    /**
     * @value Assign role to groups
     */
    ASSIGN_ROLE_TO_GROUPS = 'ROLES.ASSIGN_ROLE_TO_GROUPS',
    /**
     * @value Authorizations
     */
    AUTHORIZATIONS = 'ADMIN_ROLE_TAB_AUTHORIZATIONS',
    /**
     * @value To simplify management, create one role with only one specific authorization, instead of multiple authorizations.
     */
    AUTHORIZATIONS_HELPER = 'ROLES.AUTHORIZATIONS_HELPER',
    /**
     * @value Actions concern only their own content
     */
    CAN_EDIT_ONLY_OWN_CONTENT = 'ADMIN_ROLE_AUTHORIZATION_CAN_EDIT_ONLY_OWN_CONTENT',
    /**
     * @value Contribution modes
     * @description The title of the contribution mode section in Role administration.
     */
    CONTRIBUTION_MODE = 'ADMIN_ROLE_AUTHORIZATION.CONTRIBUTION_MODE_SECTION_TITLE',
    /**
     * @value Choose the editing capabilities for all selected content types.
     */
    CONTRIBUTION_MODE_DESCRIPTION = 'ROLES.CONTRIBUTION_MODE_DESCRIPTION',
    /**
     * @value Delete authorization?
     */
    DELETE_AUTHORIZATION = 'ROLES.DELETE_AUTHORIZATION',
    /**
     * @value Deleting the role %TITLE% is irreversible. You will delete the entire configuration.
     */
    DELETE_CONFIRMATION_MESSAGE = 'ROLES.DELETE_CONFIRMATION_MESSAGE',
    /**
     * @value Delete role?
     */
    DELETE_ROLE = 'ADMIN_ROLE_DELETE',
    /**
     * @value Role deleted successfully
     */
    DELETE_ROLE_SUCCESS = 'ADMIN_ROLE_DELETE_SUCCESS',
    /**
     * @value Designer mode
     * @description The title of the Designer mode option for the contribution mode in Role administration.
     */
    DESIGNER = 'ADMIN_ROLE_AUTHORIZATION.DESIGNER_MODE_TITLE',
    /**
     * @value Edit content and the layout (cells, rows, widgets).
     * @description The description of the Designer mode option for the contribution mode in Role administration.
     */
    DESIGNER_MODE_DESCRIPTION = 'ADMIN_ROLE_AUTHORIZATION.DESIGNER_MODE_DESCRIPTION',
    /**
     * @value Edit navigation items
     */
    EDIT_NAVIGATION_ITEMS = 'ROLES.EDIT_NAVIGATION_ITEMS',
    /**
     * @value Edit restrictions
     */
    EDIT_RESTRICTIONS = 'ROLES.EDIT_RESTRICTIONS',
    /**
     * @value This page gives you access to all roles created.
     */
    EMPTY_ROLES_DESCRIPTION = 'ROLES.EMPTY_ROLES_DESCRIPTION',
    /**
     * @value Go back to the old page of Roles
     */
    GO_BACK_TO_OLD_PAGE = 'ROLES.GO_BACK_TO_OLD_PAGE',
    /**
     * @value Select the metadata to let users perform actions on content with the selected metadata.
     */
    METADATA_DESCRIPTION = 'ROLES.METADATA_DESCRIPTION',
    /**
     * @value Navigation items
     */
    NAVIGATION_ITEMS = 'ADMIN_ROLE_AUTHORIZATION_NAVIGATION_PICKER',
    /**
     * @value Select the navigation items that can be edited with this role.
     */
    NAVIGATION_PARTIAL_EDIT_HELPER = 'ROLES.NAVIGATION_PARTIAL_EDIT_HELPER',
    /**
     * @value New authorization
     */
    NEW_AUTHORIZATION = 'ROLES.NEW_AUTHORIZATION',
    /**
     * @value New role
     */
    NEW_ROLE = 'ROLES.NEW_ROLE',
    /**
     * @value No authorizations yet
     */
    NO_AUTHORIZATIONS = 'ROLES.NO_AUTHORIZATIONS',
    /**
     * @value This section lists all the authorizations added to this role.
     */
    NO_AUTHORIZATIONS_HELPER = 'ROLES.NO_AUTHORIZATIONS_HELPER',
    /**
     * @value No navigation items yet
     */
    NO_NAV_YET = 'ROLES.NO_NAV_YET',
    /**
     * @value No restrictions yet
     */
    NO_RESTRICTIONS_YET = 'ROLES.NO_RESTRICTIONS_YET',
    /**
     * @value No roles yet
     */
    NO_ROLES_YET = 'ROLES.NO_ROLES_YET',
    /**
     * @value Enable to restrict authorization to the user's own content only.
     */
    OWNERSHIP_DESCRIPTION = 'ROLES.OWNERSHIP_DESCRIPTION',
    /**
     * @value Restrictions apply to Content types only.
     */
    RESTRICTIONS_HELPER = 'ROLES.RESTRICTIONS_HELPER',
    /**
     * @value Roles
     */
    ROLES = 'ADMIN.NAV.ROLES',
    /**
     * @value Role created
     */
    ROLE_CREATED = 'ROLES.ROLE_CREATED',
    /**
     * @value Role saved successfully
     */
    ROLE_SAVE_SUCCESS = 'ADMIN_ROLE_SAVE_SUCCESS',
    /**
     * @value Role updated
     */
    ROLE_UPDATED = 'ROLES.ROLE_UPDATED',
    /**
     * @value Try the new page of Roles
     */
    TRY_NEW_PAGE = 'ROLES.TRY_NEW_PAGE',
    /**
     * @value User's content only
     */
    USER_CONTENT_ONLY = 'ROLES.USER_CONTENT_ONLY',
    /**
     * @value Validate
     */
    VALIDATE_AUTHORIZATION = 'PORTAL.REVIEW.SUBMIT.VALIDATE',
    /**
     * @value Restrict the visibility permissions that this authorization can reach with the “visible by” settings.
     */
    VISIBILITY_DESCRIPTION = 'ROLES.VISIBILITY_DESCRIPTION',
    /**
     * @value Writer mode only
     * @description Title of the Writer mode option for Contribution mode in Role admin.
     */
    WRITER = 'ADMIN_ROLE_AUTHORIZATION.WRITER_MODE_TITLE',
    /**
     * @value Edit content without the possibility to modify the layout (cells, rows, widgets).
     * @description Description of the Writer mode option for Contribution mode in Role administration.
     */
    WRITER_MODE_DESCRIPTION = 'ADMIN_ROLE_AUTHORIZATION.WRITER_MODE_DESCRIPTION',
}
